import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Team() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Scroll smoothly after short delay
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);
  return (
    <div className="container pt-3 pb-6">
      <h2 style={{ color: "#bb790f" }}>OUR TEAM</h2>
      <div
        className="mt-4"
        id="SMurtaza"
        style={{
          border: "1px solid gray",
          padding: "20px",
          borderRadius: "4px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        }}
      >
        <h4>
          Mr. Sahibzada Murtaza Ali{" "}
          <span style={{ fontSize: "18px", color: "#bb790f" }}>
            (Advocate High Court, Founding Partner, Admitted to practice in
            2014)
          </span>
        </h4>
        <h5>Qualifications:</h5>
        <p className="m-0">Post Graduate Diploma Taxation (P.U.)</p>
        <p className="m-0">L.L.B P.U</p>
        <p className="m-0">B.A, P.U</p>
        <h5>Experience:</h5>
        <p style={{ textAlign: "justify" }}>
          Mr. Sahibzada Murtaza Ali has been associated with one of the leading
          law firms in Pakistan and a core member of the firm's lead litigation
          and M&A teams; at the forefront of ground-breaking litigation and
          transaction work. He adds hard work, panache and innovation to every
          engagement.
        </p>
        <p style={{ textAlign: "justify" }}>
          The portfolio of his clients encapsulates all market leaders and top
          entrepreneurs, individuals and companies shaping the future of
          Pakistan. His international clientele includes corporations such as
          Electro-Motive Diesel, Caterpillar and JP Morgan Chase etc
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            {" "}
            Advising on Tax, Corporate & Civil Matters, Corporate Restructuring,
            Power Sector Matters, Intellectual Property Matters, Labour Laws,
            Criminal Laws & Banking laws.
          </b>
        </p>
      </div>

      <div
        className="mt-4"
        id="GMujtaba"
        style={{
          border: "1px solid gray",
          padding: "20px",
          borderRadius: "4px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        }}
      >
        <h4>
          Mr. Ghulam Mujtaba Ilyas{" "}
          <span style={{ fontSize: "18px", color: "#bb790f" }}>
            (Advocate High Court, Partner, Admitted to practice in 2010)
          </span>
        </h4>
        <h5>Qualifications:</h5>
        <p className="m-0">
          LL.M - International Trade and Commercial Law, Durham University
        </p>
        <p className="m-0">B.A LL.B (Hons.)</p>
        <p className="m-0">Diploma in Banking Law</p>
        <h5>Experience:</h5>
        <p style={{ textAlign: "justify" }}>
          <b>
            {" "}
            Advising on Corporate, Commercial and Banking Laws, structuring,
            Contract negotiations, documentation of banking transactions,
            Mergers and Acquisitions, Financial Transactions and Corporate
            Finance, Property Laws, Civil litigation, Alternate Dispute
            Resolution, International Arbitration, Contracts, International
            Business Transactions, Environmental laws etc.
          </b>
        </p>
      </div>

      <div
        className="mt-4"
        id="SZain"
        style={{
          border: "1px solid gray",
          padding: "20px",
          borderRadius: "4px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        }}
      >
        <h4>
          Mr. Syed Zain Raza Naqvi{" "}
          <span style={{ fontSize: "18px", color: "#bb790f" }}>
            (Advocate High Court, Partner, Admitted to practice in 2015)
          </span>
        </h4>
        <h5>Qualifications:</h5>
        <p className="m-0">
          LL.M – International Banking & Finance Law, City University London
        </p>
        <p className="m-0">LL.B (Hons.), University of London</p>
        <h5>Experience:</h5>
        <p style={{ textAlign: "justify" }}>
          <b>
            {" "}
            Advising on Commercial Law, Contract law, Company Law, Real Estate
            (project development and conveyancing), Oil and Gas concessions,
            Telecommunication Laws, Infrastructure and Power Projects,
            Public-Private Partnerships, Banking Law, Financial Transactions,
            Equity and Trusts, Law of Charities and Non-Profit Organizations and
            Administration of Estates and Inheritance laws and general Civil
            law.
          </b>
        </p>
      </div>
      <div className="mt-4 row" id="associates">
        <h2 style={{ color: "#bb790f" }}>ASSOCIATES</h2>
        <div className="col-lg-4  mt-2" >
          <div class="card" style={{ width: "18rem", border: "1px solid gray", maxHeight:"192px",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 3px" }}>
            <div class="card-body">
              <h5 class="card-title">Mr. Babar Awan</h5>
              <ul style={{textAlign: "left", paddingLeft: "14px"}}>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Admitted to practice in 2021</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>LL.B. (Punjab University, Lahore)</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>B.A. (Punjab University, Lahore)</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Advocate High Court</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4  mt-2" >
          <div class="card" style={{ width: "18rem", border: "1px solid gray", maxHeight:"192px",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 3px" }}>
            <div class="card-body">
              <h5 class="card-title">Mr. H M Zeeshan Ali</h5>
              <ul style={{textAlign: "left", paddingLeft: "14px"}}>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Admitted to practice in 2019</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>B.Com, L.L.B</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>P.G.D Tax</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Advocate High Court</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4  mt-2" >
          <div class="card" style={{ width: "18rem", border: "1px solid gray", maxHeight:"192px",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 3px" }}>
            <div class="card-body">
              <h5 class="card-title">Mrs. Bushra Fatima</h5>
              <ul style={{textAlign: "left", paddingLeft: "14px"}}>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Admitted to practice in 2015</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>B.B.A (Hons)</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>MBA (Finance) I.I.U.I</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>LL.B. (Hons.) P.U.</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Advocate High Court</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4  mt-2" >
          <div class="card" style={{ width: "18rem", border: "1px solid gray", maxHeight:"192px",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 3px" }}>
            <div class="card-body">
              <h5 class="card-title">Mr. Ashhal Malik</h5>
              <ul style={{textAlign: "left", paddingLeft: "14px"}}>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Admitted to practice in 2023</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>LL.B (Hons.) University of London</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Bar-at-Law</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Advocate High Court</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4  mt-2" >
          <div class="card" style={{ width: "18rem", border: "1px solid gray", maxHeight:"192px",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 3px" }}>
            <div class="card-body">
              <h5 class="card-title">Mr. Burhan-Ul-Islam</h5>
              <ul style={{textAlign: "left", paddingLeft: "14px"}}>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Admitted to practice in 2021</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>LL.B (Hons.) University of London</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>LL.M (City University London)</p>
                </li>
                <li>
                  <p className="m-0" style={{fontSize:"13px", fontWeight:"700"}}>Advocate High Court</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
